"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = __importDefault(require("axios"));
const interceptorHandlers_1 = require("./interceptorHandlers");
const httpClient = (baseUrl) => {
    const defaultOptions = {
        baseURL: baseUrl,
    };
    const instance = axios_1.default.create(defaultOptions);
    instance.interceptors.response.use((originalResponse) => {
        (0, interceptorHandlers_1.handleDates)(originalResponse.data);
        return originalResponse;
    });
    return instance;
};
exports.default = httpClient;
